import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";

export interface ISocket {
  send: (message: string, topic: string) => void;
}

export interface IMessage {
  body: string,
  topic: string
}

export interface IKettle {
  id: string,
  temperature: number,
  setPointTemperature: number,
  saveSetPointTemperature: number,
  sound: boolean,
  backlight: boolean,
  childLock: boolean,
  night: boolean,
  connection: boolean,
  mode: number
}

export interface IKettleModeControl {
  boiling: boolean,
  heating: boolean,
  heatingHold: boolean,
  iqBoiling: boolean,
}


export interface IReceiverMode {
  usb: boolean,
  server: boolean,
  radio: boolean,
  netRadio: boolean,
  bluetooth: boolean;
}

export interface IPlayNow {
  wave: string,
  artist: string,
  track: string
}

export interface IReceiver {
  id: string,
  power: boolean,
  mute: boolean,

  mode: IReceiverMode,
  volume: number,
  playNow: IPlayNow

}

export interface IListInfo {
  text: string,
  attribute: number
}

export interface IReceiverControl {
  input: string,
  max_line: number,
  index: number,
  menu_layer: number
  menu_name: string,
  list_info: IListInfo[]
}

export interface ISensorTemperature {
  deviceId: string,
  location: string,
  battery: number
  temperature: number,
  humidity: number
}

export interface IRelay {
  deviceId: string,
  location: string,
  state: string
}

export interface IDevice {
  temperatures: Array<ISensorTemperature>,
  relays: Array<IRelay>
}


export const initialState = {
  socket: {} as ISocket,
  kettle: {} as IKettle,
  kettleMode: {boiling: true} as IKettleModeControl,
  receiver: {} as IReceiver,
  receiverNetRadioControl: {} as IReceiverControl,
  receiverUsbControl: {} as IReceiverControl,
  temperatureSensors: [] as ISensorTemperature[],
  relays: [] as IRelay[],
  response: "",
};


const slice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    setFunc: (state: IRootState, action: PayloadAction<ISocket>) => {
      state.soket = action.payload
    },
    send: (state: IRootState, action: PayloadAction<IMessage>) => {
      state.soket.send (action.payload.body, action.payload.topic)
    },
    clear: (state: IRootState) => {
      state.soket = null;
    },

    setKettle: (state: IRootState, action: PayloadAction<string>) => {
      state.kettle = JSON.parse(action.payload);
    },

    setKettleMode: (state: IRootState, action: PayloadAction<IKettleModeControl>) => {
      state.kettleMode = action.payload
    },

    setReceiver: (state: IRootState, action: PayloadAction<string>) => {
      state.receiver = JSON.parse(action.payload);
    },
    setReceiverRest: (state: IRootState, action: PayloadAction<IReceiver>) => {
      state.receiver = action.payload;
    },

    setReceiverNetRadioControl: (state: IRootState, action: PayloadAction<string>) => {
      state.receiverNetRadioControl = JSON.parse(action.payload);
    },

    setReceiverUsbControl: (state: IRootState, action: PayloadAction<string>) => {
      state.receiverUsbControl = JSON.parse(action.payload);
    },


    setDevices: (state: IRootState, action: PayloadAction<IDevice>) => {
      state.temperatureSensors = action.payload.temperatures;
      state.relays = action.payload.relays;
    },

    setTemperatureSensor: (state: IRootState, action: PayloadAction<string>) => {
      const newSensor: ISensorTemperature = JSON.parse(action.payload)
     // state.temperatureSensors = state.temperatureSensors.filter((sensor: ISensorTemperature) => sensor.id !== newSensor.id)
      state.temperatureSensors = state.temperatureSensors.map((sensorTemperature: ISensorTemperature) => {
        if (sensorTemperature.deviceId === newSensor.deviceId) {
         return  newSensor;
        } else {
          return sensorTemperature
        }
      })
     // state.temperatureSensors.push(newSensor);
    },

    setRelay: (state: IRootState, action: PayloadAction<string>) => {
      const newRelay: IRelay = JSON.parse(action.payload)
      state.relays = state.relays.map((relay: IRelay) => {
        if (relay.deviceId === newRelay.deviceId) {
          return newRelay
        } else {
          return relay;
        }
      })
    },

    resp: (state: IRootState, action: PayloadAction<string>) => {
      state.response = action.payload;
    },

  },
});

const { actions, reducer } = slice;

export { actions, reducer };
